(() => {
 const azure="https://api-elunora-production-nvo32m3ban2cc.azurewebsites.net",shops=["https://atelierelunora.com", "https://v0j63n-ms.myshopify.com", "https://www.atelierelunora.com"];
 if(!shops.includes(location.origin)||customElements.get('azure-production-gallery'))return;
 customElements.define('azure-production-gallery',class extends HTMLElement {
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController;
   const frame=this.querySelector('iframe');if(!frame)return;
   let address;try{address=new URL(frame.src);}catch{return;}
   if(address.origin!==azure||address.pathname!=='/api/gallery-preview/embed'||address.username||address.password)return;
   address.searchParams.set('parent_origin',location.origin);
   const params=new URLSearchParams(location.search),event=params.get('event');
   if(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(event||''))address.searchParams.set('event',event);
   const fragment=new URLSearchParams(location.hash.slice(1));
   if([...fragment].length===1&&/^[a-f0-9]{64}$/.test(fragment.get('booth')||''))address.hash=fragment.toString();
   frame.src=address.href;
   const openAddress=new URL(address);openAddress.pathname='/api/gallery-preview/';openAddress.searchParams.delete('parent_origin');
   const fallback=this.querySelector('[data-gallery-fallback]');if(fallback)fallback.href=openAddress.href;
   window.addEventListener('ae-navigation-open',()=>frame.contentWindow?.postMessage({type:'elunora-gallery-blur'},azure),{signal:this.controller.signal});
   window.addEventListener('message',e=>{
    if(e.origin!==azure||e.source!==frame.contentWindow||!e.data||typeof e.data!=='object')return;
    if(e.data.type==='elunora-gallery-interaction')window.dispatchEvent(new CustomEvent('ae-gallery-interaction'));
    if(e.data.type==='elunora-gallery-height'&&Number.isInteger(e.data.height)&&e.data.height>=200&&e.data.height<=200000)frame.style.height=e.data.height+'px';
    if(e.data.type==='elunora-gallery-open')location.assign(openAddress.href);
    if(e.data.type==='elunora-gallery-checkout'&&typeof e.data.url==='string'){
     let url;try{url=new URL(e.data.url);}catch{return;}
     if(shops.includes(url.origin)&&!url.username&&!url.password&&/^\/(?:cart\/c\/[^/]+|checkouts\/[^/]+)/.test(url.pathname))location.assign(url.href);
    }
   },{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();}
 });
})();
